<template>
  <div id="cur_div" v-if="node" :style=popup_style>
    <b-navbar id="navbar" variant="warning">
      <b-dropdown class="override mx-1" size="lg" :no-caret="node.children.length===1" :disabled="node.children.length===1" :text=dropdown_text>
        <div class="scrollable">
          <b-dropdown-item class="my-3" :key=kiddo.id v-for="kiddo in node.children">{{kiddo.name}}: {{kiddo.get_value().toFixed(2)}} <span v-if="kiddo.naics_code!=null">(NAICS {{kiddo.naics_code}})</span></b-dropdown-item>
        </div>
      </b-dropdown>
      <LinksList :links=node.target_links :name=incoming_text :incoming=true />
      <LinksList :links=node.source_links :name=outgoing_text :incoming=false />
      <TagList :node="node" />
      <Efficiency :node="node" />
    </b-navbar>
  </div>
</template>

<script>

import { mapGetters, mapState } from 'vuex'
import Vue from 'vue'
import LinksList from '@/components/LinksList'
import TagList from '@/components/TagList'
import Efficiency from '@/components/Efficiency'

import * as d3 from 'd3'


import utils from '../utils'

const focus = {
  inserted(el) {
    el.focus()
  },
}


export default {
  name: 'InfoPanel',
  props: [],
  components: {LinksList,TagList,Efficiency},
  data () {
    return {
    }
  },
  directives: { focus },
  computed:{
    ...mapState({
      node : state => state.cur_node,
      auth: state => state.backend.isAuthenticated,
      sigfig: state => state.sigfig
    }),
    incoming_text(){
      return "incoming value: " + this.node.get_tgt_value().toFixed(this.sigfig)
    },
    outgoing_text(){
      return "outgoing value: " + this.node.get_src_value().toFixed(this.sigfig)
    },
    dropdown_text(){
      if(this.node.children.length>1)
        return "grouped node..."
      else
        return this.node.children[0].name+": " + this.node.children[0].get_value().toFixed(this.sigfig) + (this.node.children[0].naics_code ? " (NAICS "+this.node.children[0].naics_code+")" : "")
    },
    popup_style(){
      return {
        "width":"100%",
        "position":"fixed",
        "z-index":"100",
        "left":"0px",
        "top":document.getElementById("navbar").offsetHeight+"px"
      }
    },
  },
  methods:{
  }
}
</script>

<style scoped>

#navbar{
    justify-content:left;
    padding:0px;
}

.dropdown .dropdown-menu .dropdown-item:focus {
    outline: none;
}

.dropdown >>> button {
    background: none;
    border: none;
    color: #222;
}

.override >>> button{
    color: #222;
    font-weight:bold;
}

.override >>> .disabled, :disabled{
    opacity: 1.0
}

.scrollable{
    height:auto;
    max-height:800px;
    overflow-x: visible;
}
</style>



// WEBPACK FOOTER //
// src/components/InfoPanel.vue